import SoundManager from './SoundManager';

export default class ButtonText extends Phaser.GameObjects.Text {
    
    private restColor = '#ffb800';
    private hoverColor = '#69cb1d';
    private activeColor = '#72ed12';
    private strokeColor = '#057d98';
    
    constructor(
        scene: Phaser.Scene,
        x: number,
        y: number,
        text: string,
        callback: () => void
    ) {
        super(scene, x, y, text, {}); 

        this.setInteractive({ useHandCursor: true })
            .setOrigin(0.5)
            .setPadding(10)
            .setStyle({ 
                fontFamily: 'equestria',
                fontSize: '50px',
                color: this.restColor
            })
            .setStroke(this.strokeColor, 6)
            .setShadow(0, 0, '#777', 15, true, false)
            .on('pointerover', () => this.enterHoverState() )
            .on('pointerout', () => this.enterRestState() )
            .on('pointerdown', () => this.enterActiveState() )
            .on('pointerup', () => {
                this.enterHoverState();
                callback();
            });

        scene.add.existing(this);
    }

    private enterHoverState() {
        this.setStyle({ fill: this.hoverColor });
    }
    
    private enterRestState() {
        this.setStyle({ fill: this.restColor });
    }

    private enterActiveState() {
        this.setStyle({ fill: this.activeColor });
        SoundManager.getInstance(this.scene).playButtonEffect(); 
    }
}